import { CalendarPlus, Clock } from "lucide-react";
import { AppPageHeader } from "@themes/pollinator/ui/AppPageHeader";
import { Avatar } from "@themes/pollinator/ui/Avatar";
import { Button } from "@themes/pollinator/ui/Button";
import type { Circle } from "@core/features/circle";
import { ChatButton } from "@platform/features/chat";

export type Props = {
  circle: Circle;
  isAddToCalendarDisabled: boolean;
  shouldShowChat: boolean;
  hasMeetings: boolean;
  headerDescription?: string;
  onOpenCircleDialog: () => void;
  onOpenAddCalendarEventsDialog: () => void;
};

export function ProgramCircle({
  onOpenCircleDialog,
  onOpenAddCalendarEventsDialog,
  isAddToCalendarDisabled,
  shouldShowChat,
  hasMeetings,
  headerDescription,
  circle,
}: Props) {
  return (
    <div className="flex flex-col gap-8 w-full border border-brand-800 rounded-lg px-6 py-6 mt-8 md:mt-0">
      <div className="flex flex-col gap-6 justify-between items-start w-full md:flex-row">
        <AppPageHeader
          title="Your Peer Circle"
          description={headerDescription}
          iconComponent={Clock}
        />

        {circle && (!isAddToCalendarDisabled || shouldShowChat) && (
          <div className="flex flex-row gap-2">
            {!isAddToCalendarDisabled && hasMeetings && (
              <Button
                variant="secondary"
                iconComponent={CalendarPlus}
                onClick={onOpenAddCalendarEventsDialog}
              >
                Add to Calendar
              </Button>
            )}

            {shouldShowChat && (
              <ChatButton variant="primary">Circle Chat</ChatButton>
            )}
          </div>
        )}
      </div>

      <div className="flex flex-row gap-2">
        <div className="flex flex-col gap-4 items-start md:flex-row">
          <div className="flex flex-row gap-2" onClick={onOpenCircleDialog}>
            {circle.users.map((user) => (
              <Avatar
                key={user.id}
                image={user.profile_photo}
                size={36}
                alt={`${user.first_name} ${user.last_name}`}
              />
            ))}
          </div>
          <Button
            variant="link-inline"
            className="underline md:no-underline"
            onClick={onOpenCircleDialog}
          >
            View More
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProgramCircle;
